import SmartReplyComposeSIGSData from '../store/schema/SmartReplyComposeSIGSData';
import { lazyLogSigsDatapoint } from 'owa-analytics';
import { ClientItem } from 'owa-mail-store';
import { getStore } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import { trace } from 'owa-trace';

const SIGS_CHAR_LIMIT: number = 4000;

export function logToSIGSOnRender(item: ClientItem): boolean {
    if (!!item.SIGSData && !!item.SIGSData.SmartPillData) {
        const {
            IsSmartSuggestionsRendered,
            SuggestionTypesRendered,
            SuggestionsRendered,
            ExtractionId,
        } = item.SIGSData.SmartPillData;

        const internetMessageId: string = (item as Message).InternetMessageId;

        let messageBody: string = item.UniqueBody?.Value || item.NormalizedBody?.Value;

        if (messageBody) {
            messageBody = messageBody.substring(0, SIGS_CHAR_LIMIT);
        }

        if (IsSmartSuggestionsRendered === 'True') {
            const customProperties = {
                InternetMessageId: internetMessageId,
                MessageBody: messageBody,
                SuggestionTypesRendered: SuggestionTypesRendered,
                SuggestionsRendered: SuggestionsRendered,
                ExtractionId: ExtractionId,
            };

            lazyLogSigsDatapoint.importAndExecute('SmartSuggestionsRendered', {
                compliance: 'CustomerContent',
                customProperties: customProperties,
            });

            return true;
        }
    } else {
        // Something went wrong with initializing the SIGSData object.
        trace.warn('SIGSData object not initialized on item.');
    }

    return false;
}

export function logToSIGSOnMessageSent(
    referenceItemId: string,
    content: string,
    smartReplyComposeSIGSData: SmartReplyComposeSIGSData
): void {
    // Protect with try/catch to ensure users can send messages even if this logic is faulty.
    try {
        if (referenceItemId) {
            const referenceItem: ClientItem = getStore().items.get(referenceItemId);

            if (referenceItem?.SIGSData?.SmartPillData) {
                const internetMessageId: string = (referenceItem as Message).InternetMessageId;

                let messageBody: string =
                    referenceItem.NormalizedBody?.Value || referenceItem.UniqueBody?.Value;

                if (messageBody) {
                    messageBody = messageBody.substring(0, SIGS_CHAR_LIMIT);
                }

                const replyBody: string = content.substring(0, SIGS_CHAR_LIMIT);

                lazyLogSigsDatapoint.importAndExecute('SmartSuggestionsClicked', {
                    compliance: 'CustomerContent',
                    customProperties: {
                        InternetMessageId: internetMessageId,
                        MessageBody: messageBody,
                        ...referenceItem.SIGSData.SmartPillData,
                        IsSmartSuggestionsClicked:
                            !!smartReplyComposeSIGSData &&
                            smartReplyComposeSIGSData.isSmartSuggestionsClicked
                                ? 'True'
                                : 'False',
                        SuggestionsClickedTime: smartReplyComposeSIGSData?.suggestionsClickedTime,
                        ClickIndex:
                            smartReplyComposeSIGSData &&
                            smartReplyComposeSIGSData.clickIndex.toString(),
                        ReplyBody: replyBody,
                    },
                });
            }
        }
    } catch (e) {
        trace.error(`[logToSIGSOnMessageSent] Error: ${e.message}`);
    }
}
